import { IRoofStructure } from "@/store/modules/roofStructure/types";
import { baseRoofStructure } from "./defaultObjects";
import { cloneDeep, defaultsDeep } from "lodash";

export function roofStructureDefault(
  roofStructure: Partial<IRoofStructure>
): IRoofStructure {
  return defaultsDeep(
    cloneDeep(roofStructure),
    Object.assign({}, baseRoofStructure())
  );
}
